import type { ChangeEvent } from 'react';
import { forwardRef, useEffect, useRef } from 'react';
import { Input } from '~/components/granular';
import { useDropdownContext } from '../../Dropdown';
import type { DropdownSearchProps } from './DropdownSearch.types';

export const DropdownSearch = forwardRef<HTMLInputElement, DropdownSearchProps>(
  ({ autoFocus = true, searchPlaceholder = 'Search...', onSearchChange }, forwardedRef) => {
    const { searchValue, handleSearchChange } = useDropdownContext();

    const inputRef = useRef<HTMLInputElement | null>(null);

    function handleSearch(event: ChangeEvent<HTMLInputElement>) {
      if (typeof onSearchChange === 'function') {
        onSearchChange(event);
      }
      handleSearchChange(event);
    }

    useEffect(() => {
      let timeoutId: ReturnType<typeof setTimeout>;

      if (autoFocus) {
        timeoutId = setTimeout(() => {
          inputRef.current?.focus();
        });
      }

      return () => clearTimeout(timeoutId);
    }, [autoFocus]);

    return (
      <div className="w-full px-4 py-2" ref={forwardedRef}>
        <Input
          autoFocus={autoFocus}
          leftIcon="SearchIcon"
          onChange={handleSearch}
          placeholder={searchPlaceholder}
          ref={inputRef}
          role="search"
          value={searchValue}
        />
      </div>
    );
  },
);
